module.exports = __webpack_public_path__ + "static/media/2.7159251f.png";